
import Vue from 'vue';
import Slick from 'vue-slick';

Vue.component('slick', Slick);

import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

Vue.component('swiper', swiper);
Vue.component('swiper-slide', swiperSlide);